<template>
  <div>
    <v-list-item @click="abrirDialogAdicionarProdutos()">
      <v-icon size="19">$BoxPlus</v-icon>
      <p class="ma-0 ml-2">Adicionar produtos</p>
    </v-list-item>

    <SysDialog
      v-model="dialog_adicionar_produtos"
      @click:primary="adicionarProdutos()"
      @click:hidden-dialog="fecharDialogAdicionarProdutos()"
      titulo="Produtos Carrinho"
      txtBotao="adicionar à cotação"
    >
      <sys-data-table
        v-model="adicionar_produtos_selecionados"
        :headers="headers"
        :items="desserts"
        :height="alturaDaJanela - 500"
        :item-height="25"
        :search="pesquisar"
        item-key="idproduto"
        hide-default-footer
        show-select
        class="font-resp-tabela table-full-screen elevation-1"
      >
        <template #top>
          <v-spacer />

          <v-text-field
            v-model="pesquisar"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            class="ma-0 mr-2"
            style="max-width: 450px"
          />
        </template>

        <template #item.qtde_pedido="{ item }">
          <TextFieldFormatadorDeValor
            v-model="item.qtde_pedido"
            dense
            class="text-field-centralizado font-12 w-75"
            hide-details
            :maxDigitos="0"
          />
        </template>

        <template #item.preco_custo="{ item }">
          <TextFieldFormatadorDeValor
            v-model="item.preco_custo"
            dense
            class="text-field-centralizado font-12 w-75"
            hide-details
            prefix="R$"
            :maxDigitos="2"
          />
        </template>
      </sys-data-table>
    </SysDialog>
  </div>
</template>

<script>
import Responsividade from '@/helpers/ResponsiveHeight';
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import { buscarProdutosCotacaoAtual, atualizarProdutosCotacaoPedido } from './CotacaoApi';

export default {
  mixins:[Responsividade],
  components: {
    SysDialog,
    TextFieldFormatadorDeValor
  },
  props: {
    parametros: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog_adicionar_produtos: false,
      adicionar_produtos_selecionados: [],
      desserts: [],
      pesquisar: '',
      headers: [
        { text: "Id Produto", value: "idproduto" },
        { text: "Descrição Produto", value: "descricao_produto" },
        { text: "Quantidade", value: "qtde_pedido" },
        { text: "Preço", value: "preco_custo" }
      ]
    }
  },
  watch: {
    parametros(valor) {
    }
  },
  methods: {
    abrirDialogAdicionarProdutos() {
      this.buscarProdutosTabela();
      this.$emit('fechar-dialog-anterior');
      this.dialog_adicionar_produtos = true;
    },
    fecharDialogAdicionarProdutos() {
      this.$emit('abrir-dialog-anterior');
      this.dialog_adicionar_produtos = false;
    },
    buscarProdutosTabela() {
      this.$store.dispatch(
        "loading/addRequisicao",
        buscarProdutosCotacaoAtual(this.parametros)
          .then((dados) => this.desserts = dados)
          .catch(() => this.Helpers.logout())
      );
    },
    adicionarProdutos() {
      this.$store.dispatch(
        "loading/addRequisicao",
        atualizarProdutosCotacaoPedido(this.adicionar_produtos_selecionados)
          .then(() => {
            this.adicionar_produtos_selecionados = [];
            this.fecharDialogAdicionarProdutos();
          })
          .catch(() => this.Helpers.logout())
      );
    }
  }
}
</script>

<style>

</style>
